module.exports = __webpack_public_path__ + "static/img01-5e6200fd1ea03d05d4b1ab73e9e78f1b.jpg";